export default {"src":"/_next/static/image/public/images/ic_mail.44adc8bd3ed612c67968031c1939c0e7.svg","height":36,"width":36};